<section class="main-container">

    <!--Download statement -->
    <div
        class="col-span-12 lg:col-span-3 lg:order-3 md:pr-6 pr-4 lg:pl-0 md:pl-6 pl-4 rtl:md:pr-6 rtl:pr-4 rtl:md:pl-6 rtl:pl-4 lg:border-b-0 border-b border-b-gray-300 lg:mb-0 mb-5 lg:pb-0 pb-5 h-auto">
        <app-download-statement></app-download-statement>
    </div>

    <!-- Main Content -->
    <div class="center-container lg:mr-5!">

        <!-- Search input -->
        <app-search placeholder="TABLE.SEARCH" (searchChange)="onSearchChange($event)"
            extraClass="bg-white"></app-search>

        <!-- Tabs -->
        <div class="flex flex-wrap md:gap-4 my-8">
            <button class="px-6 py-2 text-medium rounded-full cursor-pointer" *ngFor="let tab of tabs" [ngClass]="{
                'bg-(--brand-primary) text-white!': activeTab === tab.id
            }" (click)="changeActiveTab(tab.id)">{{tab.label}}</button>
        </div>

        <!-- transaction list -->
        <div class="w-full ">
            <div *ngFor="let group of transactionGroups" class="mb-8">

                <!-- Section Header -->
                <p class="text-base text-(--text-muted) font-medium mb-4 leading-6">
                    {{ group.dateLabel }}
                </p>

                <!-- Items -->
                <div *ngFor="let tx of group.transactions"
                    class="flex justify-between items-center bg-white rounded-3xl p-4 mb-4">

                    <div class="flex items-center gap-3">
                        <div
                            class="w-[52px] h-[52px] flex items-center justify-center bg-(--bg-color) rounded-full text-generic">
                            {{getInitials(tx.title )}}
                        </div>
                        <div>
                            <p class="text-medium mb-1">{{ tx.title }}</p>
                            <p class="text-sm text-gray-500">{{ tx.time }}</p>
                        </div>
                    </div>

                    <p [ngClass]="tx.type === 'outflow' ? 'text-(--color-error)' : 'text-(--text-primary)'"
                        (click)="viewTransactionDetails(tx)"
                        class="font-medium text-base cursor-pointer hover:opacity-85">
                        {{ tx.type === 'outflow' ? '-' : '+' }} {{ tx.amount | number : '1.3-3' }} <span
                            class="text-sm">{{
                            tx.currency }}</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>

<!-- Status component to view transaction details -->
<app-status-screen-component *ngIf="showStatusScreen">

    <div class="bg-white rounded-4xl text-center p-6 w-full">
        <img src="assets/icons/info-check.svg" class="mx-auto mb-8 md:w-20 md:h-20 w-14 h-14" />

        <p class="font-medium text-base leading-6 mb-5 text-(--text-muted)" *ngIf="currentTransactionView">
            {{
            (currentTransactionView?.type === 'outflow'
            ? 'TRANSACTIONS.SUCCESS_SENT'
            : 'TRANSACTIONS.SUCCESS_RECEIVED')
            | translate
            }}
        </p>

        <h2 class="mb-4 text-black text-lg font-medium flex items-center justify-center gap-2">
            <span class="md:text-4xl text-2xl font-bold">12.000</span> JOD
        </h2>

        <p class="text-base font-medium text-(--text-muted) leading-6">
            18 Sep 2025 | 8:30 AM<br />
            #3489393
        </p>

        <div class="w-full bg-white rounded-2xl border border-[#DAE1E4] mt-8">

            <!-- DESKTOP HEADER -->
            <div
                class="hidden md:grid grid-cols-12 text-base text-(--text-muted) font-medium border-b border-[#DAE1E4] p-6">

                <!-- Col 1: Sent to / Received from -->
                <p class="text-start"
                    [ngClass]="currentTransactionView?.type === 'outflow' ? 'col-span-4' : 'col-span-6'">
                    {{
                    (currentTransactionView?.type === 'outflow'
                    ? 'TRANSACTIONS.SENT_TO'
                    : 'TRANSACTIONS.RECEIVED_FROM')
                    | translate
                    }}
                </p>

                <!-- Col 2: Fees (only for outflow) -->
                <p *ngIf="currentTransactionView?.type === 'outflow'" class="text-start col-span-2">
                    {{ 'TRANSACTIONS.FEES' | translate }}
                </p>

                <!-- Col 3: Transaction type -->
                <p class="text-start"
                    [ngClass]="currentTransactionView?.type === 'outflow' ? 'col-span-3' : 'col-span-3'">
                    {{ 'TRANSACTIONS.TRANSACTION_TYPE' | translate }}
                </p>

                <!-- Col 4: Purpose -->
                <p class="text-end"
                    [ngClass]="currentTransactionView?.type === 'outflow' ? 'col-span-3' : 'col-span-3'">
                    {{ 'TRANSACTIONS.PURPOSE_OF_TRANSFER' | translate }}
                </p>
            </div>

            <!-- DATA ROW -->
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6 p-6 text-medium">

                <!-- Col 1: Received From / Sent to -->
                <div [ngClass]="currentTransactionView?.type === 'outflow' ? 'md:col-span-4' : 'md:col-span-6'">
                    <p class="md:hidden text-base text-(--text-muted) mb-2">
                        {{
                        (currentTransactionView?.type === 'outflow'
                        ? 'TRANSACTIONS.SENT_TO'
                        : 'TRANSACTIONS.RECEIVED_FROM')
                        | translate
                        }}
                    </p>

                    <div class="flex items-center gap-3 md:justify-start justify-center">
                        <div
                            class="w-12 h-12 rounded-full bg-[#F5F8F9] flex items-center justify-center text-lg font-semibold text-(--text-primary)">
                            AB
                        </div>
                        <div>
                            <p class="font-medium text-(--text-primary)">Zayn Ahmad</p>
                            <p class="text-sm text-(--text-muted)">+962 795 868 3325</p>
                        </div>
                    </div>
                </div>

                <!-- Col 2: FEES (only if outflow) -->
                <div *ngIf="currentTransactionView?.type === 'outflow'" class="md:col-span-2">
                    <p class="md:hidden text-base text-(--text-muted) mb-1">{{'TRANSACTIONS.FEES' | translate}}</p>
                    <p class="text-base text-(--text-primary) md:text-start text-center">2.000 JOD</p>
                </div>

                <!-- Col 3: Transaction Type -->
                <div class="md:col-span-3">
                    <p class="md:hidden text-base text-(--text-muted) mb-1">
                        {{ 'TRANSACTIONS.TRANSACTION_TYPE' | translate }}
                    </p>
                    <p class="text-base text-(--text-primary) md:text-start text-center">CliQ</p>
                </div>

                <!-- Col 4: Purpose -->
                <div [ngClass]="currentTransactionView?.type === 'outflow' ? 'md:col-span-3' : 'md:col-span-3'">
                    <p class="md:hidden text-base text-(--text-muted) mb-1">
                        {{ 'TRANSACTIONS.PURPOSE_OF_TRANSFER' | translate }}
                    </p>
                    <div class="flex items-center gap-2 md:justify-end justify-center">
                        <p class="text-base text-(--text-primary)">Pay rent</p>
                    </div>
                </div>
            </div>
        </div>

        <app-button text="{{ 'TRANSACTIONS.DOWNLOAD_RECEIPT' | translate }}" type="button" variant="outline" size="lg"
            iconPath="assets/icons/download-blue.svg" extraClass="md:mt-8 mt-6 w-full" (action)="downloadReceipt()">
        </app-button>

        <app-button text="{{ 'TRANSACTIONS.BACK_TO_TRANSACTIONS' | translate }}" type="button" variant="primary" size="lg"
            extraClass="md:mt-8 mt-6 w-full" (action)="backToTransactions()">
        </app-button>
    </div>

</app-status-screen-component>